import React from 'react';
export const VideoThumbnail = ({ title, onClick }) => {
    return (<div className="video-thumbnail" onClick={onClick}>
      <h3 className="video-title">{title}</h3>
      <button className="video-play-button">
        <svg width="80" height="80" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g filter="url(#a)">
            <path id="play-button-circle" fillRule="evenodd" clipRule="evenodd" d="M40 80c22.091 0 40-17.909 40-40S62.091 0 40 0 0 17.909 0 40s17.909 40 40 40Zm-6.25-25.328 22.5-12.576a2.382 2.382 0 0 0 0-4.192l-22.5-12.576c-1.667-.932-3.75.233-3.75 2.096v25.152c0 1.863 2.083 3.028 3.75 2.096Z" fill="#fff" fillOpacity=".3"/>
          </g>
          <defs>
            <filter id="a" x="-16" y="-16" width="112" height="112" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
              <feFlood floodOpacity="0" result="BackgroundImageFix"/><feGaussianBlur in="BackgroundImageFix" stdDeviation="8"/>
              <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_657_2733"/><feBlend in="SourceGraphic" in2="effect1_backgroundBlur_657_2733" result="shape"/>
            </filter>
          </defs>
        </svg>
      </button>
    </div>);
};
